// client/src/components/business/FullScreenFilterModal.js
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import FilterPanel from "./FilterPanel";
import "../../styles/components-filters.css";
import "../../styles/components-overrides.css";
import { getActiveFilterCount } from "../../utils/filterUtils";

const FullScreenFilterModal = ({
    isOpen,
    onClose,
    filters,
    onFilterChange,
    onApplyFilters,
}) => {
    const modalRef = useRef(null);
    const { t } = useTranslation();

    // Handle escape key and backdrop click
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === "Escape") onClose();
        };

        const handleBackdropClick = (e) => {
            if (modalRef.current && e.target === modalRef.current) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener("keydown", handleEscape);
            document.addEventListener("click", handleBackdropClick);
            document.body.style.overflow = "hidden"; // Prevent background scroll
        }

        return () => {
            document.removeEventListener("keydown", handleEscape);
            document.removeEventListener("click", handleBackdropClick);
            document.body.style.overflow = "unset";
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    const handleApply = () => {
        onApplyFilters();
        onClose();
    };

    const activeCount = getActiveFilterCount(filters);

    return (
        <div className="filter-modal-overlay" ref={modalRef}>
            <div className="filter-modal-content">
                {/* Modal Header */}
                <div className="filter-modal-header">
                    <div className="filter-modal-title">
                        <h2>{t('filters.filtersTitle')}</h2>
                        <span className="filter-subtitle">
                            {t('businessList.adjustFilters')}
                        </span>
                    </div>
                    <button
                        className="filter-modal-close"
                        onClick={onClose}
                        title="Close filters"
                    >
                        ✕
                    </button>
                </div>

                {/* Modal Body */}
                <div className="filter-modal-body">
                    <FilterPanel
                        filters={filters}
                        onFilterChange={onFilterChange}
                        isFullScreen={true}
                    />
                </div>

                {/* Modal Footer */}
                <div className="filter-modal-footer">
                    <div className="filter-modal-actions">
                        <button
                            className="filter-apply-btn"
                            onClick={handleApply}
                        >
                            {t('filters.applyFilters')}
                            {activeCount > 0 && (
                                <span className="apply-count">
                                    ({activeCount})
                                </span>
                            )}
                        </button>
                        <button className="filter-clear-btn" onClick={onClose}>
                            {t('common.cancel')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FullScreenFilterModal;
